import Tags from "./Tags";

const ChipRender = (params) => {
  return <Tags chips={params?.data?.tags || []}></Tags>;
};

export default ChipRender;
